// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__15a0o","signatureButtonsRight":"ModalSign_signatureButtonsRight__3uvO1"};